/* Elite Wijnkoelkast – premium productpagina (sectie elite-product) */
(function () {
  var root = document.querySelector('[data-ep]');
  if (!root) return;

  // Galerij: miniaturen en vegen
  var slides = root.querySelectorAll('[data-ep-slide]');
  var thumbs = root.querySelectorAll('[data-ep-thumb]');
  var current = 0;
  function show(i) {
    current = i;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-ep-thumb'), 10)); });
  });
  var main = root.querySelector('.ep-gallery__main');
  var startX = null;
  if (main && slides.length > 1) {
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show((current + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      startX = null;
    });
  }

  // Vergelijk-tab alleen tonen als er een vergelijking is
  if (root.querySelector('[data-ep-compare]')) {
    var cl = root.querySelector('[data-ep-compare-link]');
    if (cl) cl.hidden = false;
  }

  // Navigatie onder de vaste header, actieve tab en koopbalk
  var nav = root.querySelector('[data-ep-nav]');
  var header = document.querySelector('.site-header');
  var buy = root.querySelector('[data-ep-buy]');
  var sticky = root.querySelector('[data-ep-sticky]');
  var links = nav ? nav.querySelectorAll('a[href^="#"]') : [];
  var ticking = false;
  function headerOffset() {
    if (!header) return 0;
    var r = header.getBoundingClientRect();
    return r.bottom > 0 && r.top <= 0 ? Math.round(r.bottom) : 0;
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.style.setProperty('--ep-top', headerOffset() + 'px');
      if (buy && sticky) {
        var past = buy.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }
      var y = (nav ? nav.getBoundingClientRect().bottom : 0) + 40;
      links.forEach(function (a) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        var r = t.getBoundingClientRect();
        a.classList.toggle('is-active', r.top <= y && r.bottom > y);
      });
      ticking = false;
    });
  }
  function jump(e) {
    var t = document.querySelector(this.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    var offset = (nav ? nav.offsetHeight : 0) + headerOffset();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - offset + 1, behavior: 'smooth' });
  }
  links.forEach(function (a) { a.addEventListener('click', jump); });
  root.querySelectorAll('[data-ep-jump]').forEach(function (a) { a.addEventListener('click', jump); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  // Past deze in mijn keuken?
  var fit = root.querySelector('[data-ep-fit]');
  if (fit) {
    var num = function (v) { var n = parseFloat(String(v || '').replace(',', '.')); return isNaN(n) ? null : n; };
    var p = {
      h: num(fit.dataset.h), b: num(fit.dataset.b), d: num(fit.dataset.d),
      nmin: num(fit.dataset.nmin), nmax: num(fit.dataset.nmax),
      inbouw: fit.dataset.inbouw === 'true'
    };
    var out = fit.querySelector('[data-fit-result]');
    var inputs = fit.querySelectorAll('[data-fit]');
    var fmt = function (n) { return String(Math.round(n * 10) / 10).replace('.', ','); };
    var check = function () {
      var v = {};
      inputs.forEach(function (i) { v[i.dataset.fit] = num(i.value); });
      if (v.h === null && v.b === null && v.d === null) { out.textContent = ''; out.className = 'ep-fit__result'; return; }
      var issues = [];
      if (v.h !== null) {
        if (p.inbouw && p.nmin !== null) {
          if (v.h < p.nmin) issues.push('de nis is ' + fmt(p.nmin - v.h) + ' cm te laag (minimaal ' + fmt(p.nmin) + ' cm)');
          else if (p.nmax !== null && v.h > p.nmax + 0.5) issues.push('de nis is hoger dan ' + fmt(p.nmax) + ' cm; een afdekpaneel of aangepaste nis is nodig');
        } else if (p.h !== null && v.h < p.h) {
          issues.push('de hoogte is ' + fmt(p.h - v.h) + ' cm te weinig');
        }
      }
      if (v.b !== null && p.b !== null && v.b < p.b) issues.push('de breedte is ' + fmt(p.b - v.b) + ' cm te smal');
      if (v.d !== null && p.d !== null && v.d < p.d) issues.push('de diepte is ' + fmt(p.d - v.d) + ' cm te ondiep');
      if (issues.length) {
        out.className = 'ep-fit__result is-no';
        out.textContent = 'Dit model past waarschijnlijk niet: ' + issues.join(', ') + '. Wij adviseren u graag over een alternatief.';
      } else {
        out.className = 'ep-fit__result is-ok';
        out.textContent = 'Op basis van deze maten past dit model.' + (p.inbouw ? ' Controleer voor de inbouw altijd de inbouwtekening.' : ' Houd rondom ruimte vrij voor ventilatie.');
      }
    };
    inputs.forEach(function (i) { i.addEventListener('input', check); });
  }
})();
